import { Authenticated } from '../middlewares'

export default [
    {
        path: '/faqs',
        name: 'faqs.index',
        component: () => import('../../views/faq/index.vue'),
        meta: {
            middleware: Authenticated,
            breadcrumbs: [
                { route: () => ({ name: 'faqs.index' }), label: ({ lang }) => lang.app.list_of_faqs, loading: () => false }
            ]
        }
    },
]